import React from 'react';
import { FaTools } from 'react-icons/fa';

function App() {
    return (
        <main className="maintenance" role="main">
            <section className="maintenance__content" aria-labelledby="maintenance-title">
                <div className="maintenance__icon" aria-hidden="true">
                    <FaTools />
                </div>
                <h1 id="maintenance-title">
                    <span>En</span>
                    mantenimiento
                </h1>
                <p>(Disculpe las molestias)</p>
                <br /><br />
                <img
                    className="maintenance__logo"
                    src="/images/logo2.ico"
                    alt="Zu Luz"
                />
            </section>
        </main>
    );
}

export default App;
